export function adjustSecondDateToMatchFirst(a, b) {
    if (a == null || b == null) {
        return b;
    }

    const dateA = a instanceof Date ? a : new Date(a);
    const dateB = b instanceof Date ? b : new Date(b);

    return new Date(
        dateA.getFullYear(),
        dateA.getMonth(),
        dateA.getDate(),
        dateB.getHours(),
        dateB.getMinutes(),
        dateB.getSeconds(),
        dateB.getMilliseconds()
    );
}
